module.exports = __webpack_public_path__ + "roboto-latin-500.87284894879f5b1c229cb49c8ff6decc.woff";